import { render, staticRenderFns } from "./params-observer.vue?vue&type=template&id=5dec2efb"
import script from "./params-observer.vue?vue&type=script&lang=js"
export * from "./params-observer.vue?vue&type=script&lang=js"
import style0 from "./params-observer.vue?vue&type=style&index=0&id=5dec2efb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports